export default {
  records: null,
  recordToCreate: null,
  recordDeletionPending: [],
  recordCreationPending: false
}
